export function isEvidenceFile(mime: string): boolean {
  if (
    mime === 'text/csv' ||
    !(mime.startsWith('text') || mime === 'application/protobuf')
  ) {
    return true
  }
  return false
}
